import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { useCallback } from "react";
import { SchemaData, useCreateProps } from "./types";
import { CreateGql, CREATE_QUERY } from "../queries/create";
import { useNavigate } from "react-router-dom";
import { ApiGetCouseERPRequest } from "data/apiGetCourseERP";

export default function useCreate(props: useCreateProps) {
  const navigate = useNavigate();

  const handleSave = useCallback(async (state: JsonFormsStateProps<SchemaData>) => {
    const { updatedAt, createdAt, ...data } = state?.data;
    console.log({ data });
    const response = await ApiGetCouseERPRequest<CreateGql>({
      query: CREATE_QUERY,
      variables: {
        data: {
          ...data,
        },
      },
    });

    if (response?.data?.errors) {
      throw response.data.errors[0];
    }
    if (!response?.data?.data || !response?.data?.data?.createEducationalUnitConversion?.id) {
      throw new Error("Ops. Sem resposta!");
    }

    navigate(
      `${props.sitePath}/conversao-unidade/${response.data.data.createEducationalUnitConversion.id}`
    );

    return response;
  }, []);

  return {
    handleSave,
  };
}
